module.exports = __webpack_public_path__ + "assets/img/1031587020684_.pic_hd.695f0614.jpg";